import {
    apiRequest,
    skpnsApprove,
    skpnsDetail
} from '../../../../../services/adapters/kepegawaian/skpnsService'

class UpdateRepository {

    fetchApprove = async (query) => {
        return await apiRequest("post", skpnsApprove, {
            body: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", skpnsDetail, {
            params: query
        }, true)
    }

}

export default UpdateRepository